module.exports = __webpack_public_path__ + "static/img/1.41f3bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/afterSale/1.png
// module id = KjKH
// module chunks = 1